<template>
    <div class="ns-loader-spinner">
        <loading-template></loading-template>
        <span class="loader-text">{{loadingText}}</span>
    </div>
</template>

<script>
import { LoadingTemplate } from 'gcmcn-common';
export default {

    components: {
        LoadingTemplate
    },

    props: {
        loadingText:{
            type: String,
            default: ''
        }
    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">
.ns-loader-spinner{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 300px;
    .loader-text{
        font-size: 18px;
        margin-top: 1rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ns-loader-template.vue